export default "__VITE_ASSET__ChlDU486__"